import type { AddonFilter, EventData } from '../types.tsx';
import { withConnectHost } from './ecosystem-connect-host.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (eventName: string, addonFilter: AddonFilter, eventData?: EventData) => {
	withConnectHost((host) => {
		host && host.broadcastEvent(eventName, addonFilter, eventData);
	});
};
